import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ThreadToggleUnreadButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleUnreadButton';
import { ThreadToggleStarredButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleStarredButton';
import { ThreadToggleArchivedButton } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleArchivedButton';
import { IconButton, MenuItem } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Popover from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import fr from 'facet-rest';
import usePopoverState from 'Hooks/usePopoverState';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('MobileThreadQuickActions', (theme) => ({
  paper: {
    padding: theme.spacing(1, 0),
  },
  quickActionsIcon: {
    padding: theme.spacing(0),
  },
  quickActionMenuButton: {
    width: '100%',
    justifyContent: 'flex-start',
  },
}));

const MobileThreadQuickActions = ({
  threadResource,
  size,
  color,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
  } = usePopoverState({});

  const handleMenuClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openPopover(e);
  };

  const handleMenuClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleClose(e);
  };

  return (
    <React.Fragment>
      <IconButton
        className={classes.quickActionsIcon}
        color={'actionActive'}
        icon={MoreVertIcon}
        onClick={(e) => handleMenuClick(e)}
        {...DataValueMap
          .init('messages-page-thread-list-quick-action-menu')
          .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
          .build()}
      />
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={(e) => handleMenuClose(e)}
        PaperProps={{ className: classes.paper }}
      >
        <MenuItem>
          <ThreadToggleStarredButton
            className={classes.quickActionMenuButton}
            resource={threadResource}
            color={color}
            size={size}
            onChange={handleClose}
            fullWidth
            showLabel
          />
        </MenuItem>
        <MenuItem>
          <ThreadToggleUnreadButton
            className={classes.quickActionMenuButton}
            resource={threadResource}
            color={color}
            size={size}
            onChange={handleClose}
            showLabel
            fullWidth
          />
        </MenuItem>
        <MenuItem>
          <ThreadToggleArchivedButton
            className={classes.quickActionMenuButton}
            resource={threadResource}
            color={color}
            size={size}
            onChange={handleClose}
            fullWidth
            showLabel
          />
        </MenuItem>
      </Popover>
    </React.Fragment>
  );
};

MobileThreadQuickActions.defaultProps = {
  size: 'default',
  color: 'actionActive',
};

MobileThreadQuickActions.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
};

export { MobileThreadQuickActions };
